import { render } from "./MenuItemChildMenuResponder.vue?vue&type=template&id=21200d33"
import script from "./MenuItemChildMenuResponder.vue?vue&type=script&lang=js"
export * from "./MenuItemChildMenuResponder.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__